export const DATE_FORMAT = (providerDateFormat) => providerDateFormat || window.DATE_FORMAT || "MM/dd/yyyy"